import { findCountrySearchMatchRange } from '@/modules/countries/utils/countrySearch'

interface CountrySearchHighlightProps {
  name: string
  query: string
  className?: string
}

/** Renders a country name with the matching search prefix highlighted. */
export function CountrySearchHighlight({ name, query, className = '' }: CountrySearchHighlightProps) {
  const range = findCountrySearchMatchRange(name, query)
  if (!range) {
    return <span className={className}>{name}</span>
  }

  return (
    <span className={className}>
      {name.slice(0, range.start)}
      <mark className="bg-amber-200 text-gray-900 rounded-sm px-0.5 font-semibold">
        {name.slice(range.start, range.end)}
      </mark>
      {name.slice(range.end)}
    </span>
  )
}
